import React from 'react';
import { FiClock } from 'react-icons/fi';
import { getBlockedHoursForDate } from '../data/carsData';

const HourlyView = ({ carId, date, bookings = null, blocks = null }) => {
  if (!date) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-center">
        <FiClock className="w-12 h-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500">Please select a date to view hourly availability</p>
      </div>
    );
  }

  const blockedHours = getBlockedHoursForDate(carId, date, bookings, blocks);
  
  // Check if an hour is blocked
  const isHourBlocked = (hour) => {
    return blockedHours.some(range => hour >= range.from && hour < range.to);
  };

  // Generate all 24 hours
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const formatHourForDisplay = (hour) => {
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:00 ${period}`;
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6">
      <div className="flex items-center gap-2 mb-3 sm:mb-4">
        <FiClock className="w-4 h-4 sm:w-5 sm:h-5 text-primary-600" />
        <h3 className="text-base sm:text-lg font-bold text-gray-900">Hourly Availability</h3>
      </div>
      <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
        View available and booked hours for the selected date
      </p>
      
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
        {hours.map((hour) => {
          const blocked = isHourBlocked(hour);
          
          return (
            <div
              key={hour}
              className={`p-2 sm:p-2.5 rounded-lg border-2 text-center text-xs sm:text-sm font-medium h-14 sm:h-16 flex flex-col items-center justify-center ${
                blocked
                  ? 'border-red-200 bg-red-50 text-red-600'
                  : 'border-green-200 bg-green-50 text-green-700'
              }`}
            >
              <div className="font-semibold">{formatHourForDisplay(hour)}</div>
            </div>
          );
        })}
      </div>

      {blockedHours.length > 0 && (
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-xs font-medium text-amber-900 mb-1">Booked Hours on This Date:</p>
          <div className="text-xs text-amber-700">
            {blockedHours.map((range, index) => (
              <div key={index}>
                • {formatHourForDisplay(range.from)} - {formatHourForDisplay(range.to)}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-4 flex flex-wrap items-center gap-4 text-xs">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded border-2 border-green-200 bg-green-50"></div>
          <span className="text-gray-600">Available</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded border-2 border-red-200 bg-red-50"></div>
          <span className="text-gray-600">Booked</span>
        </div>
      </div>
    </div>
  );
};

export default HourlyView;
